import { type Payouts } from '@airwallex/components-sdk'

import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import { type PaymentMethodCategoryType } from '@webapp/platform/banking/entities/enums/PaymentMethodCategoryEnum'
import messages from './messages'
import { useCreateBeneficiaryPresenter } from './useCreateBeneficiaryPresenter'
import {
  CreateBeneficiaryForm,
  MOUNT_ELEMENT_ID,
} from '../../views/CreateBeneficiaryForm'

export interface ICreateBeneficiaryFormPresenterProps {
  paymentMethodCategory: Exclude<
    PaymentMethodCategoryType,
    'EXTERNAL' | 'INTERNATIONAL_US'
  >
  onSubmit: (
    beneficiaryFormSubmitResponse: Payouts.BeneficiaryFormSubmitResponse
  ) => void
  onBack: () => void
}

export const CreateBeneficiaryFormPresenter = ({
  paymentMethodCategory,
  onSubmit,
  onBack,
}: ICreateBeneficiaryFormPresenterProps) => {
  const intl = useProcurifyIntl()

  const handleError = (error: Error) => {
    toast.error({
      title: intl.formatMessage(messages.errorToastTitle),
      children: error.message,
    })
  }

  const { isReady, isInitializing, isSubmitting, handleSubmit } =
    useCreateBeneficiaryPresenter({
      paymentMethodCategory,
      mountElementId: MOUNT_ELEMENT_ID,
      onSubmit,
      onError: handleError,
    })

  return (
    <CreateBeneficiaryForm
      onSubmit={handleSubmit}
      onBack={onBack}
      isDisabled={!isReady || isSubmitting || isInitializing}
      isLoading={isInitializing}
      isSubmitting={isSubmitting}
    />
  )
}
